export enum SkeletonActionTypes {
    INITIALIZE = "[App Action][Skeleton] INITIALIZE",
    INITIALIZE_SUCCESS = "[App Action][Skeleton] INITIALIZE SUCCESS",
    INITIALIZE_FAIL = "[App Action][Skeleton] INITIALIZE FAIL",

    LOADING = "[App Action][Skeleton] LOADING",
    NOT_LOADING = "[App Action][Skeleton] NOT LOADING",
    /*
    GET_API_ROUTES = "[App Action][Skeleton] GET API ROUTES",
    GET_API_ROUTES_SUCCESS = "[App Action][Skeleton] GET API ROUTES SUCCESS",
    GET_API_ROUTES_FAIL = "[App Action][Skeleton] GET API ROUTES FAIL",

     */

    READ_SUBAPPS_CONFIG = "[App Action][Skeleton] READ SUBAPPS CONFIG",

    UPDATE_ACTIVE_SUBAPPS = "[App Action][Skeleton] UPDATE ACTIVE SUBAPPS"
}
